import React from 'react';

const RequirementItem = ({ status, header, onClick, dataTest }) => {
  switch (status) {
    case "draft":
      return (
        <a onClick={onClick} className="cardSection _withColumns _simple _noMinHeight" data-test={dataTest}>
          <div className="text _widthAuto">
            <p className="label emphasize"> {header} </p>
          </div>
          <i className="materialIcon --small _right">keyboard_arrow_right</i>
        </a>
      );

    case "verified":
      return (
        <section className="cardSection -bgSuccessLight _withColumns _simple --micro _whiteBorderBottom">
          <div className="text _widthAuto">
            <p className="label emphasize -success wrap-txt">{header}</p>
          </div><i className="materialIcon --small _right -success">done</i>
        </section>
      );

    case "resubmit":
      return (
        <a onClick={onClick} className="cardSection _withColumns _simple _noMinHeight -bgWarningLight _whiteBorderBottom" data-test={dataTest}>
          <div className="text _widthAuto">
            <small className="preamble --small -warning">Resubmit</small>
            <p className="label emphasize -warning">{header}</p>
          </div>
          <i className="materialIcon _right --small -warning">keyboard_arrow_right</i>
        </a>
      );
    default:
      return (
        <section className="cardSection _disabled _withColumns _simple _noMinHeight _whiteBorderBottom">
          <div className="text _widthAuto">
            <p className="label emphasize"> {header} </p>
          </div>
          <i className="materialIcon _right _withBorder">lock</i>
        </section>
      )
  }
};

export default RequirementItem;



// WEBPACK FOOTER //
// ./src/features/home/components/RequirementItem.js